/* [04]-STUDIOS / V5 story media. Pause offscreen Shopify-hosted background videos.
   No changes to copy, slideshow timings, navigation or scroll behavior. */
(() => {
  'use strict';
  if (window.__04StoryVideoController) return;
  window.__04StoryVideoController = true;
  const tracked = new Set();
  const isActive = (video) => {
    if (document.hidden || !video.isConnected) return false;
    const style = getComputedStyle(video);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
      rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const sync = (video) => {
    if (isActive(video)) {
      video.muted = true;
      if (video.paused) video.play().catch(() => {});
    } else if (!video.paused) video.pause();
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        for (const entry of entries) sync(entry.target);
      }, {rootMargin: '50px 0px', threshold: 0})
    : null;
  const mount = (root = document) => {
    const videos = root.querySelectorAll('.a04-story__video, .ln04-scene__video');
    for (const video of videos) {
      if (tracked.has(video)) continue;
      tracked.add(video);
      video.muted = true;
      if (observer) observer.observe(video);
      sync(video);
    }
  };
  const resync = () => {
    for (const video of tracked) {
      if (!video.isConnected) {
        observer?.unobserve(video);
        tracked.delete(video);
      } else sync(video);
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(document), {once:true});
  } else mount(document);
  window.addEventListener('resize', resync, {passive:true});
  document.addEventListener('visibilitychange', resync);
  document.addEventListener('shopify:section:load', event => {
    mount(event.target);
    resync();
  });
  document.addEventListener('shopify:section:unload', resync);
})();
